module.exports = __webpack_public_path__ + "static/media/informations.ef70d78e.svg";